import { fromEvent, Subject } from 'rxjs';

export interface ScreenSizeDO {
  width: number;
  height: number;
}

const screenSizeSubject = new Subject<ScreenSizeDO>();

fromEvent(window, 'resize').subscribe(() => {
  const { innerWidth, innerHeight } = window;
  screenSizeSubject.next({ width: innerWidth, height: innerHeight });
});

export { screenSizeSubject };
